import { useSetAtom } from 'jotai';

import { enqueueModalAtom } from '@/atoms/modalQueueAtoms';
import { AwarenessCard } from '@/components/awareness-card';
import { SessionMergeIcon } from '@/components/icons/session-merge-icon';
import { useQueuedModal } from '@/hooks/useQueuedModal';
import { useSessionMergeOnboardingAnalytics } from '@/models/analytics/features/useSessionMergeOnboardingAnalytics';
import {
  configureSessionMergeOnboardingUi,
  type SessionMergeOnboardingUiHost,
} from '@heidi/session';
import { CoachMark } from '@heidi/snowflake-ui/coach-mark';

/**
 * Binds the app modal queue, the promo analytics and the three shared app
 * components into @heidi/session's session-merge onboarding host. The hooks
 * cross BY REFERENCE (rules of hooks apply through them); the enqueue setter
 * reads the same atom and store as before.
 */

const useEnqueueModal: SessionMergeOnboardingUiHost['useEnqueueModal'] = () =>
  useSetAtom(enqueueModalAtom);

export const sessionMergeOnboardingUiHost: SessionMergeOnboardingUiHost = {
  useQueuedModal,
  useEnqueueModal,
  useSessionMergeOnboardingAnalytics,
  CoachMark,
  AwarenessCard,
  SessionMergeIcon,
};

configureSessionMergeOnboardingUi(sessionMergeOnboardingUiHost);
